// สถานะร้านแบบสดบน Firestore stores/{storeId} (ดู composables/useStoreStatus.ts)
//
// trigger: jobchain เปลี่ยน (jobs.length / lastupdate) = ทุกครั้งที่มี job เข้า
//          โต๊ะถูกคำนวณใหม่ (tables) และใบเสร็จเปลี่ยน (void / fetch)
// subscribe ทุกโหมด แล้วไปเช็คโหมดตอนเขียน — เหตุผลเดียวกับ mobile.items.plugin
// (อ่าน getMode() ตอน store ถูกสร้างอาจยังไม่ได้ค่า)

import { PiniaPluginContext } from "pinia";
import { scheduleStoreStatusWrite } from "../composables/useStoreStatus";

function StoreStatusPlugin({ store }: PiniaPluginContext) {
  if (store.$id === "jobs") {
    let prevLength = -1;
    let prevLastupdate: any = null;
    let prevTables: any = null;

    store.$subscribe((_mutation, state: any) => {
      const length = state.jobs?.length || 0;
      if (length !== prevLength || state.lastupdate !== prevLastupdate || state.tables !== prevTables) {
        prevLength = length;
        prevLastupdate = state.lastupdate;
        prevTables = state.tables;
        scheduleStoreStatusWrite();
      }
    });
    return;
  }

  if (store.$id === "receipts") {
    let prevReceipts: any = null;
    let prevLength = -1;

    store.$subscribe((_mutation, state: any) => {
      const length = state.receipts?.length || 0;
      if (state.receipts !== prevReceipts || length !== prevLength) {
        prevReceipts = state.receipts;
        prevLength = length;
        scheduleStoreStatusWrite();
      }
    });
  }
}

export default defineNuxtPlugin(({ $pinia }) => {
  $pinia.use(StoreStatusPlugin);
});
